/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import Constant from '@/common/constant/Constant';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import LoadingPanel from '@/component/common/LoadingPanel';
import Logger from '@/common/utils/Logger';
import { getRichTextFieldContent } from '@/component/ticketList/handler/TicketHandler';
import { getFormListByCorporation } from '@/service/formManagementService';
import { getProjectById } from '@/service/projectService';
import { getTicketById } from '@/service/ticketService';
import { getListViewInProject } from '@/service/viewService';
import {
    updatePreviewCategoryListAtom,
    updatePreviewSettingAtom
} from '@/state/atom/chatBotPreview';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { closeTabId, multiPanelAtom, panelInitDataAtom } from '@/state/atom/panelAtom';
import { userAtom } from '@/state/atom/userAtom';
import {
    closePanelTabSelector,
    setPanelSelector,
    triggerReloadTicketListByPanelType
} from '@/state/selector/panelSelector';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import {
    Button,
    Chip,
    FormControl,
    FormControlLabel,
    InputAdornment,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField
} from '@material-ui/core';
import { Storage } from 'aws-amplify';
import { cloneDeep, orderBy } from 'lodash';
import { useSnackbar } from 'notistack';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { openPromptTicketPanel } from '../chatAI/handler/ChatAIHandler';
import { getDefaultMessageConfigJSON } from '@/service/messageResolverService';
import OverFlowTooltipWithCustomCss from '../common/OverFlowTooltipWithCustomCss';
import RichTextEditorForSettingChatbot from '../formManagement/fieldUI/RichTextEditorForSettingChatbot';
import { getNumberFormStrings } from '../formManagement/handler/CommonHandler';
import { removePanelInitData, updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import CancelTabsDialog from '../system/dialog/CancelTabsDialog';
import CategoryChatBotComponent from './CategoryChatBotComponent';
import SettingCategory from './SettingCategory';
import './SettingChatbot.css';
import SettingHeaderIconChatbot from './SettingHeaderIconChatbot';
import SettingLogoChatbot from './SettingLogoChatbot';
import SettingSendIconChatbot from './SettingSendIconChatbot';
import {
    getBooleanValueOptionDisplayLength,
    getCategoryListOfProject,
    getError,
    getValue,
    handleClickRemoveBasicPromptSetting,
    handleOnBlurBasicPromptSetting,
    onSubmitSetting,
    validateChatbotName,
    validateChatbotTextInHeader,
    validateMaxLengthAnswers,
    validateNumberHitKnowledgeTicket,
    validateNumberOptionDisplayLength,
    validateKLRoboMessageConfig
} from './handler/SettingChatbotHandler.js';
import { pushClientLog } from '@/service/logService';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import I18n from '@/rI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

const initDataSetting = {
    isActivateChatbot: false,
    usingAI: false,
    basicPrompt: '',
    useImageInAnswer: false,
    actionWhenNotResolve: Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE,
    freeMsg: '',
    htmlScript: '',
    chatbotName: '',
    headerIcon: Constant.SETTING_CHAT_BOT.LOGO_ICON_DEFAULT,
    logo: Constant.SETTING_CHAT_BOT.LOGO_ICON_DEFAULT,
    sendIcon: Constant.SETTING_CHAT_BOT.SEND_LOGO,
    maxNumberAnswer: Constant.SETTING_CHAT_BOT.MAX_LENGTH_ANSWER.DEFAULT,
    headersColor: '#17494D',
    chatbotTextInHeader: '',
    numberHitKnowledgeTicket: 5,
    styleSheet: '',
    messageConfig: getDefaultMessageConfigJSON(true),
    versionKnowledgeRoboStyleCss: 1,
    enableListTicket: true
};

const BackToDefault = () => {
    return (
        <svg
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.07024 0.404628C8.50152 0.203255 9.95947 0.472493 11.2244 1.17177C12.4894 1.87106 13.4928 2.9625 14.0835 4.28165C14.6742 5.6008 14.8202 7.07621 14.4995 8.48555C14.1788 9.89489 13.4088 11.1618 12.3054 12.0955C11.202 13.0291 9.8251 13.5789 8.38212 13.6619C6.93913 13.745 5.50824 13.3568 4.30504 12.5559C3.10184 11.755 2.19151 10.5848 1.71122 9.22158C1.58887 8.87431 1.7712 8.49361 2.11847 8.37126C2.46574 8.24892 2.84644 8.43125 2.96878 8.77852C3.35302 9.86911 4.08128 10.8053 5.04384 11.446C6.0064 12.0867 7.15111 12.3972 8.3055 12.3308C9.45989 12.2644 10.5614 11.8245 11.4441 11.0776C12.3268 10.3307 12.9429 9.31717 13.1994 8.18969C13.456 7.06222 13.3392 5.8819 12.8666 4.82658C12.3941 3.77125 11.5913 2.8981 10.5794 2.33867C9.56739 1.77925 8.40102 1.56386 7.256 1.72496C6.11098 1.88606 5.04932 2.41492 4.23101 3.23185C4.22625 3.2366 4.22142 3.24128 4.21652 3.24588L2.3497 5.00005H4.66667C5.03486 5.00005 5.33333 5.29852 5.33333 5.66671C5.33333 6.0349 5.03486 6.33338 4.66667 6.33338H0.666667C0.298477 6.33338 0 6.0349 0 5.66671V1.66672C0 1.29853 0.298477 1.00005 0.666667 1.00005C1.03486 1.00005 1.33333 1.29853 1.33333 1.66672V4.12547L3.29632 2.28094C4.31823 1.26392 5.64237 0.60552 7.07024 0.404628Z"
                fill="#2D72D2"
            />
        </svg>
    );
};

export default function SettingChatbot(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const corporationDetail = useRecoilValue(corporationAtom);
    const [userDetail, setUserDetail] = useRecoilState(userAtom);
    const [projectInuseDetail, setProjectInuseDetail] = useState({});
    const [croppedHeaderIcon, setCroppedHeaderIcon] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);
    const [croppedSendIcon, setCroppedSendIcon] = useState(null);
    const [settingData, setSettingData] = useState(initDataSetting);
    const [errors, setErrors] = useState({});
    const [displayHeadersColorPicker, setDisplayHeadersColorPicker] = useState(false);
    const [dataHtmlScript, setDataHtmlScript] = useState('');
    const [reloadPage, setReloadPage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [isEdited, setIsEdited] = useState(false);
    const [isOpenConfirmReset, setIsOpenConfirmReset] = useState(false);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const panelList = useRecoilValue(multiPanelAtom);
    const [isShowDialogReload, setIsShowDialogReload] = useState(false);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [isOpenSettingCategoty, setIsOpenSettingCategoty] = useState(false);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [valueFreeMsg, setValueFreeMsg] = useState('');
    const [isUpdateDataFreeMsg, setIsUpdateDataFreeMsg] = useState('');

    const [previewSetting, setPreviewSetting] = useRecoilState(updatePreviewSettingAtom);
    const [previewCategoryList, setPreviewCategoryList] = useRecoilState(
        updatePreviewCategoryListAtom
    );
    const [formQAList, setFormQAList] = useState([]);
    const [customerViewList, setCustomerViewList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [chatBotCategorySetting, setChatbotCategorySetting] = useState({});
    const [chatBotCategoryList, setChatbotCategoryList] = useState([]);
    const [titleCategory, setTitleCategory] = useState('');
    const [editCategoryId, setEditCategoryId] = useState(null);
    const [isEditCategoryDetail, setIsEditCategoryDetail] = useState(false);
    const [removedCategoryId, setRemovedCategoryId] = useState(null);
    const [isDisableBtnSubmit, setIsDisableBtnSubmit] = useState(true);
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);
    const [basicPromptSetting, setBasicPromptSetting] = useState(false);
    const [errorBasicPrompt, setErrorBasicPrompt] = useState();
    const [basicPromptDetail, setBasicPromptDetail] = useState({});

    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isShowDialogBacktoDefault, setIsShowDialogBacktoDefault] = useState(false);
    const [isShowDialogResetMessageConfig, setIsShowDialogResetMessageConfig] = useState(false);
    
    const [isCssFallback, setIsCssFallback] = useState(false);
    const [isShowUploadError, setIsShowUploadError] = useState(false);
    const [logoFileName, setLogoFileName] = useState('');
    const [headerLogoName, setHeaderLogoName] = useState('');
    const [sendLogoName, setSendLogoName] = useState('');

    let projectInuseId = localStorageUtil.getSelectedProjectId();

    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    // Css color picker
    const popover = {
        position: 'absolute',
        zIndex: '2',
        top: '33px',
        left: '0px'
    };
    const cover = {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px'
    };

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            initPageData();
            reloadTicketListByPanelType({
                panelType: Constant.PANEL_TYPE.PREVIEW_CHATBOT
            });
        }
        return () => {
            isMounted = false;
        };
    }, [reloadPage, props.triggerReload]);

    useEffect(() => {
        if (isEdited) {
            updatePanelInitData(
                props.panelId,
                props.tabId,
                panelInitData,
                setPanelInitData,
                'isEditedData',
                true
            );
        } else {
            removePanelInitData(
                props.panelId,
                props.tabId,
                panelInitData,
                setPanelInitData,
                'isEditedData',
                true
            );
        }
    }, [isEdited]);

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            if (props.tabId === closeTabIdState) {
                if (isEdited) {
                    setIsConfirmCancelTabs(true);
                } else {
                    closePanelTab({
                        event: null,
                        panelType: props.panelType,
                        panelId: props.panelId,
                        tabId: props.tabId
                    });
                }
                setCloseTabIdState(0);
            }
        }
        return () => {
            isMounted = false;
        };
    }, [closeTabIdState]);

    const initViewAndFormInCorporation = async () => {
        const [formList, viewList] = await Promise.all([
            getFormListByCorporation(props?.API, corporationDetail.id,{from :0, size: 300, isGetForList: true }, []),
            getListViewInProject(
                props?.API,
                projectInuseId,
                projectInuseId,
                Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
            )
        ]);
        if (formList?.length) {
            let formListActive = formList.map(form => {
                return {
                    ...form,
                    name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, form.name)
                };
            });
            formListActive = formListActive.filter(
                form =>
                    form.type === Constant.FORM_TYPE.FORM_REQ_QA &&
                    form.usingProjects?.includes(projectInuseId) &&
                    !Utils.isSystemTelephoneForm(form)
            );
            formListActive = orderBy(formListActive, [form => form.name.toLowerCase()], ['asc']);
            setFormQAList(formListActive);
        }

        if (viewList?.length) {
            let settingViewList = viewList.map(view => {
                return {
                    ...view,
                    // Keep the original JSON name so getViewDisplayName can translate system views;
                    // `name` is flattened to a string for sort/filter/value only.
                    nameOrigin: view.name,
                    name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, view.name)
                };
            });
            settingViewList = settingViewList.filter(
                view =>
                    Utils.convertJSONDataToObject(view.structure).ticketProperty !==
                    Constant.TICKET_PROPERTY.DELETE
            );
            settingViewList = orderBy(settingViewList, [view => view.name.toLowerCase()], ['asc']);
            setCustomerViewList(settingViewList);
        }
    };

    const initPageData = async () => {
        setIsLoading(true);
        let cssFallbackStatus = false;
        try {
            let [ projectDetail, listCategories ] = await Promise.all([
                getProjectById(props?.API, projectInuseId),
                getCategoryListOfProject(props?.API, projectInuseId),
                initViewAndFormInCorporation()
            ]);

            setProjectInuseDetail(projectDetail);
            setIsEdited(false);

            setErrors({});
            let currentSettingData = Utils.convertJSONDataToObject(projectDetail?.chatbotSetting);
            let initData = { ...initDataSetting };

            // Get style sheet of knowledge robo
            const currentRoboStyleVersion = currentSettingData?.versionKnowledgeRoboStyleCss;
            let roboStyleContent = '';
            if (currentRoboStyleVersion) {
                let fileKey = Constant.DEFAULT_PATH_STYLE_KNOWLEDGE_ROBO_SETTINGS;
                if (currentRoboStyleVersion > 1) // when create project versionKnowledgeRoboStyleCss of robo setting = 1. It's default style
                    fileKey = Utils.genKeyFileCss(
                        corporationDetail.id,
                        projectDetail.id,
                        currentRoboStyleVersion,
                        Constant.KEY_FILE_CSS_TYPE.KNOWLEDGE_ROBO
                    );
                
                try {
                    const getFileResult = await Storage.get(fileKey, {
                        download: true,
                        cacheControl: 'no-cache'
                    });
                    roboStyleContent = await new Response(getFileResult.Body).text();
                } catch (cssError) {
                    // Push to backend
                    pushClientLog('', {
                        cssError: cssError?.message || String(cssError),
                        action: Constant.PUSH_LOG_CLIENT_ACTION.STORAGE_ERR,
                        projectInuseId: projectInuseId,
                        fileKey: Constant.DEFAULT_PATH_STYLE_KNOWLEDGE_ROBO_SETTINGS
                    });
                    Logger.error('SettingChatbot - get CSS error, fallback to default: ', cssError);
                    const defaultCssResponse = await fetch('/assets/knowledge-robo-default-style.css');
                    roboStyleContent = await defaultCssResponse.text();
                    cssFallbackStatus = true;
                }
            }

            // Get message config of knowledge robo
            // Default for first time (no S3 path), but keep actual value (even empty) if already saved
            let initMessageConfig = getDefaultMessageConfigJSON(true);
            const currentMessageConfigS3Path = currentSettingData?.messageConfig;
            if (currentMessageConfigS3Path) {
                try {
                    const msgConfigS3File = await Storage.get(currentMessageConfigS3Path, {
                        download: true,
                        cacheControl: 'no-cache'
                    });
                    const msgConfigContent = await new Response(msgConfigS3File.Body).text();
                    // Keep the actual value from S3 (even if empty) for UI display
                    initMessageConfig = msgConfigContent;
                } catch (error) {
                    console.log('Error getting message config from S3, use default config. Error: ', error);
                }
            }

            if (!Utils.isEmptyObject(currentSettingData)) {
                initData = {
                    isActivateChatbot: currentSettingData.isActivateChatbot,
                    usingAI: currentSettingData.usingAI ? currentSettingData.usingAI : false,
                    useImageInAnswer: currentSettingData.useImageInAnswer,
                    freeMsg: currentSettingData.freeMsg,
                    actionWhenNotResolve:
                        currentSettingData.actionWhenNotResolve ||
                        Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE,
                    maxNumberAnswer:
                        currentSettingData.maxNumberAnswer ||
                        Constant.SETTING_CHAT_BOT.MAX_LENGTH_ANSWER.DEFAULT,
                    htmlScript: currentSettingData.htmlScript,
                    headerIcon: currentSettingData?.headerIcon,
                    logo: currentSettingData.logo,
                    sendIcon: currentSettingData?.sendIcon,
                    chatbotTextInHeader: currentSettingData.chatbotTextInHeader,
                    headersColor: currentSettingData.headersColor,
                    chatbotName: currentSettingData.chatbotName,
                    numberHitKnowledgeTicket:
                        currentSettingData.numberHitKnowledgeTicket ||
                        Constant.SETTING_CHAT_BOT.NUMBER_HIT_KNOWLEDGE_TICKET.DEFAULT,
                    projectAlias: projectDetail.projectAlias,
                    optionDisplayLength: currentSettingData.optionDisplayLength || 0,
                    basicPrompt: currentSettingData?.basicPrompt ? currentSettingData?.basicPrompt : '',
                    styleSheet: roboStyleContent,
                    messageConfig: initMessageConfig,
                    versionKnowledgeRoboStyleCss: currentRoboStyleVersion,
                    enableListTicket: currentSettingData?.hasOwnProperty('enableListTicket') ? currentSettingData.enableListTicket : true
                };
                setValueFreeMsg(currentSettingData.freeMsg);
                setDataHtmlScript(currentSettingData.htmlScript);

                if (currentSettingData?.basicPrompt) {
                    const ticketId = await Utils.getTicketIdByShareLink(
                        currentSettingData?.basicPrompt
                    );
                    const basicTicket = await getTicketById(null, ticketId);
                    if (basicTicket) {
                        setBasicPromptDetail(basicTicket);
                        setBasicPromptSetting(initData.basicPrompt);
                    }
                } else {
                    setBasicPromptSetting('');
                }

                let newCategoryList = [];
                if (!Utils.isEmptyArray(currentSettingData.categoryList)) {
                    newCategoryList = await Promise.all(
                        currentSettingData.categoryList.map(async category => {
                            const categoryChatbot = await getProjectById(props?.API, category.id);
                            category.name = Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                categoryChatbot.name
                            );
                            return category;
                        })
                    );
                }
                setPreviewSetting(prev => ({
                    ...prev,
                    projectAlias: projectDetail.projectAlias,
                    newCategoryList: newCategoryList
                }));
                setPreviewCategoryList([...listCategories]);
                setCategoryList(newCategoryList);
            }

            let initDataPreview = cloneDeep(initData);
            delete initDataPreview.logo;
            delete initDataPreview.sendIcon;
            delete initDataPreview.headerIcon;
            initDataPreview.projectAlias = projectDetail?.projectAlias;

            setPreviewSetting(prev => ({ ...prev, ...initDataPreview }));
            setSettingData(initData);
            setIsLoading(false)
            setIsUpdateDataFreeMsg(Date.now);
        } catch (error) {
            Logger.error('SettingChatbot - initPageData error: ', error);
        } finally {
            setIsCssFallback(cssFallbackStatus);
            setIsLoading(false);
        }
    };

    const checkRequired = fieldName => {
        let settingDataClone = { ...settingData };
        let errorsClone = { ...errors };
        switch (fieldName) {
            case 'chatbotTextInHeader':
                let errChatbotTextInHeader = validateChatbotTextInHeader(
                    settingDataClone.chatbotTextInHeader
                );
                if (Utils.isEmptyString(errChatbotTextInHeader)) {
                    delete errorsClone.chatbotTextInHeader;
                } else {
                    errorsClone.chatbotTextInHeader = errChatbotTextInHeader;
                }
                break;
            case 'chatbotName':
                let errChatbotName = validateChatbotName(settingDataClone.chatbotName);
                if (Utils.isEmptyString(errChatbotName)) {
                    delete errorsClone.chatbotName;
                } else {
                    errorsClone.chatbotName = errChatbotName;
                }
                break;
            default:
                break;
        }
        setErrors(errorsClone);
    };

    const onChangePreviewSetting = (fieldName, settingDataParams = { ...settingData }) => {
        switch (fieldName) {
            case 'useImageInAnswer':
                setPreviewSetting(prev => ({
                    ...prev,
                    useImageInAnswer: getValue(settingDataParams, 'useImageInAnswer')
                }));
                break;
            case 'numberHitKnowledgeTicket':
                setPreviewSetting(prev => ({
                    ...prev,
                    numberHitKnowledgeTicket: getValue(
                        settingDataParams,
                        'numberHitKnowledgeTicket'
                    )
                }));
                break;
            case 'maxNumberAnswer':
                setPreviewSetting(prev => ({
                    ...prev,
                    maxNumberAnswer: getValue(settingDataParams, 'maxNumberAnswer')
                }));
                break;
            case 'freeMsg':
                setPreviewSetting(prev => ({ ...prev, freeMsg: valueFreeMsg }));
                break;
            case 'chatbotTextInHeader':
                setPreviewSetting(prev => ({
                    ...prev,
                    chatbotTextInHeader: getValue(settingDataParams, 'chatbotTextInHeader')
                }));
                break;
            case 'headersColor':
                setPreviewSetting(prev => ({
                    ...prev,
                    headersColor: getValue(settingDataParams, 'headersColor')
                }));
                break;
            case 'chatbotName':
                setPreviewSetting(prev => ({
                    ...prev,
                    chatbotName: getValue(settingDataParams, 'chatbotName')
                }));
                break;
            case 'actionWhenNotResolve':
                setPreviewSetting(prev => ({
                    ...prev,
                    actionWhenNotResolve: getValue(settingDataParams, 'actionWhenNotResolve')
                }));
                break;
            case 'enableListTicket':
                setPreviewSetting(prev => ({
                    ...prev,
                    enableListTicket: getValue(settingDataParams, 'enableListTicket')
                }));
                break;
            default:
                break;
        }
    };

    const onValidateNumber = field => {
        let settingDataClone = { ...settingData };
        let errorsClone = { ...errors };
        switch (field) {
            case 'numberHitKnowledgeTicket':
                let valueNumberHitKnowledgeTicket = getValue(
                    settingData,
                    'numberHitKnowledgeTicket'
                );
                if (valueNumberHitKnowledgeTicket === '') {
                    break;
                }
                if (typeof valueNumberHitKnowledgeTicket === 'string') {
                    valueNumberHitKnowledgeTicket = getNumberFormStrings(
                        'POSITIVE_INTEGER',
                        valueNumberHitKnowledgeTicket
                    );
                } else if (typeof valueNumberHitKnowledgeTicket !== 'number') {
                    valueNumberHitKnowledgeTicket =
                        Constant.SETTING_CHAT_BOT.NUMBER_HIT_KNOWLEDGE_TICKET.DEFAULT;
                }
                if (
                    valueNumberHitKnowledgeTicket >
                    Constant.SETTING_CHAT_BOT.NUMBER_HIT_KNOWLEDGE_TICKET.MAX
                ) {
                    valueNumberHitKnowledgeTicket =
                        Constant.SETTING_CHAT_BOT.NUMBER_HIT_KNOWLEDGE_TICKET.MAX;
                } else if (valueNumberHitKnowledgeTicket === 0) {
                    valueNumberHitKnowledgeTicket =
                        Constant.SETTING_CHAT_BOT.NUMBER_HIT_KNOWLEDGE_TICKET.MIN;
                }
                settingDataClone.numberHitKnowledgeTicket = valueNumberHitKnowledgeTicket;
                delete errorsClone.numberHitKnowledgeTicket;
                break;
            case 'maxNumberAnswer':
                let maxValue = getValue(settingData, 'maxNumberAnswer');
                if (maxValue === '') {
                    break;
                }
                if (typeof maxValue === 'string') {
                    maxValue = getNumberFormStrings('POSITIVE_INTEGER', maxValue);
                } else if (typeof maxValue !== 'number') {
                    maxValue = Constant.SETTING_CHAT_BOT.MAX_LENGTH_ANSWER.DEFAULT;
                }
                if (maxValue === 0) {
                    maxValue = Constant.SETTING_CHAT_BOT.MAX_LENGTH_ANSWER.MIN;
                } else if (maxValue > Constant.SETTING_CHAT_BOT.MAX_LENGTH_ANSWER.MAX) {
                    maxValue = Constant.SETTING_CHAT_BOT.MAX_LENGTH_ANSWER.MAX;
                }
                settingDataClone.maxNumberAnswer = maxValue;
                delete errorsClone.maxNumberAnswer;
                break;

            case 'optionDisplayLength':
                let newOptionDisplayLength = getValue(settingData, 'optionDisplayLength');
                if (newOptionDisplayLength === '') {
                    break;
                }
                if (typeof newOptionDisplayLength === 'string') {
                    newOptionDisplayLength = getNumberFormStrings(
                        'POSITIVE_INTEGER',
                        newOptionDisplayLength
                    );
                } else if (typeof newOptionDisplayLength !== 'number') {
                    newOptionDisplayLength =
                        Constant.SETTING_CHAT_BOT.MAX_OPTION_DISPLAY_LENGTH.DEFAULT;
                }
                if (
                    newOptionDisplayLength > Constant.SETTING_CHAT_BOT.MAX_OPTION_DISPLAY_LENGTH.MAX
                ) {
                    errorsClone.optionDisplayLength = validateNumberOptionDisplayLength(
                        newOptionDisplayLength
                    );
                } else {
                    delete errorsClone.optionDisplayLength;
                    if (newOptionDisplayLength === 0) {
                        newOptionDisplayLength =
                            Constant.SETTING_CHAT_BOT.MAX_OPTION_DISPLAY_LENGTH.MIN;
                    }
                }
                settingDataClone.optionDisplayLength = newOptionDisplayLength;
                break;
            default:
                break;
        }
        setSettingData(settingDataClone);
        if (field === 'numberHitKnowledgeTicket') {
            onChangePreviewSetting('numberHitKnowledgeTicket');
        } else if (field === 'maxNumberAnswer') {
            onChangePreviewSetting('maxNumberAnswer');
        }
        setErrors(errorsClone);
    };

    const onChangeData = (event, fieldName) => {
        let settingDataClone = { ...settingData };
        let errorsClone = { ...errors };
        let currentValue = '';
        switch (fieldName) {
            case 'isActivateChatbot':
                currentValue = settingDataClone.isActivateChatbot;
                settingDataClone.isActivateChatbot = !currentValue;
                settingDataClone.freeMsg = valueFreeMsg;
                break;
            case 'usingAI':
                currentValue = settingDataClone.usingAI;
                settingDataClone.usingAI = !currentValue;
                settingDataClone.freeMsg = valueFreeMsg;
                if (!settingDataClone.usingAI) {
                    settingDataClone.enableListTicket = true;
                }
                break;
            case 'useImageInAnswer':
                currentValue = settingDataClone.useImageInAnswer;
                settingDataClone.useImageInAnswer = !currentValue;
                onChangePreviewSetting('useImageInAnswer', settingDataClone);
                break;
            case 'actionWhenNotResolve':
                let newSetting = event.target.value;
                settingDataClone.actionWhenNotResolve = newSetting;
                onChangePreviewSetting('actionWhenNotResolve', settingDataClone);
                setValueFreeMsg(settingData.freeMsg);
                if (newSetting == Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE) {
                    let contentText = getRichTextFieldContent(valueFreeMsg);
                    if (Utils.isEmptyString(contentText)) {
                        errorsClone.freeMsg = 'COMMSG014';
                    } else {
                        delete errorsClone.freeMsg;
                    }
                } else {
                    delete errorsClone.freeMsg;
                }
                onChangePreviewSetting('freeMsg', settingDataClone);
                break;
            case 'maxNumberAnswer':
                const dataMaxNumberAnswer = event.replace(/[^\d.-]+/g, '');
                const maxValue = parseInt(dataMaxNumberAnswer);
                if (!maxValue || maxValue === 0) {
                    settingDataClone.maxNumberAnswer = '';
                } else {
                    settingDataClone.maxNumberAnswer = maxValue;
                }
                let invalidMaxNumberAnswer = validateMaxLengthAnswers(maxValue);
                if (Utils.isEmptyString(invalidMaxNumberAnswer)) {
                    delete errorsClone.maxNumberAnswer;
                } else {
                    errorsClone.maxNumberAnswer = invalidMaxNumberAnswer;
                }
                break;
            case 'htmlScript':
                let newValueHtmlScript = event.target.value;
                if (Utils.isEmptyString(newValueHtmlScript)) {
                    setDataHtmlScript(newValueHtmlScript);
                }
                break;
            case 'headersColor':
                settingDataClone.headersColor = event;
                break;
            case 'chatbotName':
                let newValueChatbotName = event?.target?.value;
                settingDataClone.chatbotName = newValueChatbotName;
                let errChatbotName = validateChatbotName(newValueChatbotName);
                if (Utils.isEmptyString(errChatbotName)) {
                    delete errorsClone.chatbotName;
                } else {
                    errorsClone.chatbotName = errChatbotName;
                }
                break;
            case 'chatbotTextInHeader':
                let newValueChatbotTextInHeader = event?.target?.value;
                settingDataClone.chatbotTextInHeader = newValueChatbotTextInHeader;
                let errChatbotTextInHeader = validateChatbotTextInHeader(
                    newValueChatbotTextInHeader
                );
                if (Utils.isEmptyString(errChatbotTextInHeader)) {
                    delete errorsClone.chatbotTextInHeader;
                } else {
                    errorsClone.chatbotTextInHeader = errChatbotTextInHeader;
                }
                break;
            case 'numberHitKnowledgeTicket':
                const dataNumberHitKnowledgeTicket = event.replace(/[^\d.-]+/g, '');
                const valueNumberHitKnowledgeTicket = parseInt(dataNumberHitKnowledgeTicket);
                if (!valueNumberHitKnowledgeTicket || valueNumberHitKnowledgeTicket === 0) {
                    settingDataClone.numberHitKnowledgeTicket = '';
                } else {
                    settingDataClone.numberHitKnowledgeTicket = valueNumberHitKnowledgeTicket;
                }

                let invalidNumberHitKnowledgeTicket = validateNumberHitKnowledgeTicket(
                    parseInt(valueNumberHitKnowledgeTicket)
                );
                if (Utils.isEmptyString(invalidNumberHitKnowledgeTicket)) {
                    delete errorsClone.numberHitKnowledgeTicket;
                } else {
                    errorsClone.numberHitKnowledgeTicket = invalidNumberHitKnowledgeTicket;
                }
                break;

            case 'optionDisplayLengthRadio':
                let newSelectedOption = event.target.value;
                let newOptionDisplayLengthValue = settingDataClone?.optionDisplayLength
                    ? settingDataClone?.optionDisplayLength
                    : Constant.SETTING_CHAT_BOT.MAX_OPTION_DISPLAY_LENGTH.DEFAULT;
                if (newSelectedOption == 'false') {
                    newOptionDisplayLengthValue = 0;
                    delete errorsClone.optionDisplayLength;
                }
                settingDataClone.optionDisplayLength = newOptionDisplayLengthValue;
                break;

            case 'optionDisplayLength':
                const dataNumberOptionDisplayLength = event.replace(/[^\d.-]+/g, '');
                if (dataNumberOptionDisplayLength === '') {
                    settingDataClone.optionDisplayLength = '';
                    errorsClone.optionDisplayLength = trI18n('MSG-CM-REQUIRED-INPUT');
                } else {
                    const valueNumberOptionDisplayLength = parseInt(dataNumberOptionDisplayLength);
                    if (valueNumberOptionDisplayLength === 0) return;
                    if (!valueNumberOptionDisplayLength) {
                        settingDataClone.optionDisplayLength = 0;
                    } else {
                        settingDataClone.optionDisplayLength = valueNumberOptionDisplayLength;
                    }

                    let invalidNumberOptionDisplayLength = validateNumberOptionDisplayLength(
                        parseInt(valueNumberOptionDisplayLength)
                    );
                    if (Utils.isEmptyString(invalidNumberOptionDisplayLength)) {
                        delete errorsClone.optionDisplayLength;
                    } else {
                        errorsClone.optionDisplayLength = invalidNumberOptionDisplayLength;
                    }
                }
                break;
            case 'styleSheet':
                let newValueStyleSheet = event.target.value;
                settingDataClone.styleSheet = newValueStyleSheet;
                let errMsgStyleSheet = Utils.validateStyleSheet(newValueStyleSheet);
                if (Utils.isEmptyString(errMsgStyleSheet)) {
                    delete errorsClone.styleSheet;
                    setPreviewSetting((preState)=>{
                        return {...preState, styleSheet: newValueStyleSheet}
                    })
                } else {
                    errorsClone.styleSheet = errMsgStyleSheet;
                }
                break;
            case 'messageConfig':
                let newValueMessageConfig = event.target.value;
                settingDataClone.messageConfig = newValueMessageConfig;
                
                // validation
                let errMsgMessageConfig = validateKLRoboMessageConfig(newValueMessageConfig);
                if (Utils.isEmptyString(errMsgMessageConfig)) {
                    delete errorsClone.messageConfig;
                } else {
                    errorsClone.messageConfig = errMsgMessageConfig;
                }

                setPreviewSetting((preState) => {
                    return {...preState, messageConfig: newValueMessageConfig}
                });
                break;
            case 'enableListTicket':
                currentValue = settingDataClone.enableListTicket;
                settingDataClone.enableListTicket = !currentValue;
                onChangePreviewSetting('enableListTicket', settingDataClone);
                break;
            default:
                break;
        }
        
        const hasValidateErrors = !Utils.isEmptyObject(errorsClone) || isNotInputFieldsRequired(settingDataClone)
        setIsEdited(true);
        setIsDisableBtnSubmit(hasValidateErrors);
        setSettingData(settingDataClone);
        setErrors(errorsClone);
    };

    const isNotInputFieldsRequired = data => {
        return (
            Utils.isEmptyString(data.maxNumberAnswer) ||
            Utils.isEmptyString(data.numberHitKnowledgeTicket) ||
            Utils.isEmptyString(data.chatbotTextInHeader) ||
            Utils.isEmptyString(data.chatbotName) ||
            Utils.isEmptyString(data.styleSheet) ||
            (Utils.isEmptyString(getRichTextFieldContent(valueFreeMsg)) &&
            data.actionWhenNotResolve ===
                    Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE)
        );
    };

    const isDisabledCancelSettingChatbot = () => {
        if (isEdited) {
            return false;
        }
        return true;
    };

    const isNotError = () => {
        if (Utils.isEmptyObject(errors)) {
            return false;
        }
        return true;
    };

    const onClickToggleCategorySetting = value => {
        setIsOpenSettingCategoty(value);
        setIsEditCategoryDetail(false);
        if (value) {
            setTitleCategory('');
            setChatbotCategorySetting({});
            setEditCategoryId('');
        }
    };

    const onAddPanelPreview = () => {
        const isExistPanelPreviewIndex = panelList.findIndex(panel => panel.type === Constant.PANEL_TYPE.PREVIEW_CHATBOT);

        if (isExistPanelPreviewIndex >= 0) {
            addNewPanel({
                type: Constant.PANEL_TYPE.PREVIEW_CHATBOT,
                currentPanelId: props?.panelId,
                tabId: `${Constant.PANEL_TYPE.PREVIEW_CHATBOT}_${Date.now().toString()}`,
                props
            });

        } else {
            addNewPanel({
                type: Constant.PANEL_TYPE.PREVIEW_CHATBOT,
                tabId: `${Constant.PANEL_TYPE.PREVIEW_CHATBOT}_${Date.now().toString()}`,
                props
            });
        }
    };

    const onClickDetailCategoryChatbot = (categoryId, isCategoryEdit) => {
        if (Utils.getPrefixOfId(categoryId) === 'category' && !isCategoryEdit) {
            setIsLoading(true);

            getProjectById(props?.API, categoryId).then(categoryDetail => {
                setIsEditCategoryDetail(true);
                setEditCategoryId(categoryId);
                setChatbotCategorySetting(
                    Utils.convertJSONDataToObject(categoryDetail.chatBotCategorySetting)
                );
                setTitleCategory(
                    Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, categoryDetail.name)
                );
                setIsOpenSettingCategoty(true);
                setIsLoading(false);
            });
        } else {
            chatBotCategoryList.forEach(category => {
                if (category.tempId === categoryId) {
                    setIsEditCategoryDetail(true);
                    setEditCategoryId(categoryId);
                    setTitleCategory(category.titleCategory);
                    setChatbotCategorySetting(category);
                    setIsOpenSettingCategoty(true);
                    return;
                }
            });
            setIsLoading(false);
        }
    };

    const onRemoveCategory = categoryId => {
        setIsLoading(true);

        const newCategoryList = categoryList.filter(category => category.id !== categoryId);
        setCategoryList(newCategoryList);
        const deletedChatbotCategorySetting = {
            deleteId: categoryId
        };
        setChatbotCategoryList([...chatBotCategoryList, deletedChatbotCategorySetting]);
        setIsEdited(true);
        setIsLoading(false);

        const newCategoryListForPreView = previewCategoryList.filter(
            category => category.id !== categoryId
        );
        setPreviewCategoryList([...newCategoryListForPreView]);
    };

    /**
     * toggle chat AI in org info turn on
     * @returns boolean
     */
    const isDisplayAIChatSetting = () => {
        if (
            [
                corporationDetail?.limitValue?.usingChatAI,
                corporationDetail?.knowledgeService,
                corporationDetail?.limitValue?.knowledgeBot
            ].includes(Constant.STATUS_SERVICE_PERMISSION.OFF)
        )
            return false;
        return true;
    };

    const onHandleBacktoDefault = async () => {
        setIsShowDialogBacktoDefault(false);
        setIsEdited(true);
        let fileKeyDefaultCss = Constant.DEFAULT_PATH_STYLE_KNOWLEDGE_ROBO_SETTINGS;
        setErrors(prev => {
            let prevClone = { ...prev };
            delete prevClone.styleSheet;
            return prevClone;
        });
        let styleSheet = '';
        try {
            let getFileResult = await Storage.get(fileKeyDefaultCss, {
                download: true,
                cacheControl: 'no-cache'
            });
            styleSheet = await new Response(getFileResult.Body).text();
        } catch (cssError) {
            pushClientLog('', {
                cssError: cssError?.message || String(cssError),
                action: Constant.PUSH_LOG_CLIENT_ACTION.STORAGE_ERR,
                fileKey: fileKeyDefaultCss
            });
            Logger.error('SettingChatbot - onHandleBacktoDefault get CSS error, fallback to default: ', cssError);
            const defaultCssResponse = await fetch('/assets/knowledge-robo-default-style.css');
            styleSheet = await defaultCssResponse.text();
        }
        setSettingData(prev => ({
            ...prev,
            styleSheet: styleSheet
        }));

        // reset preview setting
        setPreviewSetting((preState)=>{
            return {...preState, styleSheet: styleSheet}
        })
        setIsCssFallback(false);
        setIsEdited(true)
        setIsDisableBtnSubmit(false)
    };

    const onHandleResetMessageConfig = () => {
        setIsShowDialogResetMessageConfig(false);
        setIsEdited(true);

        setErrors(prev => {
            let prevClone = { ...prev };
            delete prevClone.messageConfig;
            return prevClone;
        });
        
        // Generate default JSON in-memory (NOT from S3)
        const defaultMessageConfig = getDefaultMessageConfigJSON(true);
        
        setSettingData(prev => ({
            ...prev,
            messageConfig: defaultMessageConfig
        }));
        
        // Update preview setting
        setPreviewSetting((preState) => {
            return {...preState, messageConfig: defaultMessageConfig}
        });
        
        setIsEdited(true);
        setIsDisableBtnSubmit(false);
    };

    const onClickNoWhenClickDontSave = () => {
        setReloadPage(Date.now().toString());
        setIsOpenConfirmReset(false);
        setCroppedImage(null);
        setIsDisableBtnSubmit(true);
        setCroppedHeaderIcon(null);
        setCroppedSendIcon(null);
        if (settingData.sendIcon != Constant.SETTING_CHAT_BOT.SEND_LOGO) {
            setSendLogoName(
                Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, corporationDetail.name)
            );
        } else {
            setSendLogoName('');
        }

        if (settingData.logo !== Constant.SETTING_CHAT_BOT.LOGO_ICON_DEFAULT) {
            setLogoFileName(
                Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, corporationDetail.name)
            );
        } else {
            setLogoFileName('');
        }

        if (settingData.headerIcon !== Constant.SETTING_CHAT_BOT.LOGO_ICON_DEFAULT) {
            setHeaderLogoName(
                Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, corporationDetail.name)
            );
        } else {
            setHeaderLogoName('');
        }
    };

    const isDisableButtonSubmit = () => {
        return isDisableBtnSubmit || !Utils.isEmptyString(errorBasicPrompt);
    }

    const renderChatbotSetting = () => {
        return (
            <div className="chatbotSetting">
                <LoadingPanel isLoading={isLoading} />
                <div className="groupSetting category-active">
                    <div className="advanced-setting-onoff">
                        <h3>{trI18n('PLKNOWLB023')}</h3>
                        <div className="groupBtn">
                            <Button
                                variant="contained"
                                className="btn-hg32 btn-light"
                                color="primary"
                                onClick={() => setIsOpenConfirmReset(true)}
                                disabled={isDisabledCancelSettingChatbot()}
                            >
                                {tr('キャンセル')}
                            </Button>

                            <Button
                                onClick={() =>
                                    onSubmitSetting(
                                        corporationDetail,
                                        projectInuseDetail,
                                        settingData,
                                        valueFreeMsg,
                                        croppedHeaderIcon,
                                        croppedImage,
                                        croppedSendIcon,
                                        setCroppedImage,
                                        setCroppedHeaderIcon,
                                        setCroppedSendIcon,
                                        errors,
                                        setErrors,
                                        enqueueSnackbar,
                                        setIsLoading,
                                        setReloadPage,
                                        isEdited,
                                        setIsShowDialogReload,
                                        dataHtmlScript,
                                        categoryList,
                                        chatBotCategorySetting,
                                        setChatbotCategorySetting,
                                        titleCategory,
                                        userDetail.id,
                                        chatBotCategoryList,
                                        setChatbotCategoryList,
                                        setIsDisableBtnSubmit,
                                        setIsEdited,
                                        props?.API,
                                        basicPromptDetail,
                                        setErrorBasicPrompt,
                                        setIsShowUploadError
                                    )
                                }
                                disabled={isDisableButtonSubmit()}
                                variant="contained"
                                className="btn-hg32 btn-primary"
                                color="primary"
                            >
                                {trI18n('COMBTN011')}
                            </Button>
                        </div>
                    </div>
                </div>

                {/* category active  */}
                <div className="groupSetting category-active">
                    <div className="advanced-setting-title">
                        <h3>{trI18n('PLKNOWLB024')}</h3>
                        <div className="preview-chatbot" onClick={onAddPanelPreview}>
                            <div>{tr('プレビュー')}</div>
                            <img src="/assets/image/preview-chatbot.svg" alt="preview" />
                        </div>
                    </div>
                    <div className="groupSettingContent">
                        <div className="groupSettingItem">
                            <label className="settingLable">{trI18n('PLKNOWLB012')}</label>
                            <div className="switch-check">
                                <input
                                    type="checkbox"
                                    id="isActivateChatbot"
                                    // defaultChecked={getValue(settingData, 'isActivateChatbot')}
                                    checked={getValue(settingData, 'isActivateChatbot')}
                                    readOnly
                                />
                                <label
                                    htmlFor="isActivateChatbot"
                                    onClick={e => onChangeData(e, 'isActivateChatbot')}
                                >
                                    <span className="switch-text"></span>
                                </label>
                            </div>
                        </div>
                        {isDisplayAIChatSetting() && (
                            <>
                                <div className="groupSettingItem">
                                    <label className="settingLable">
                                        {trI18n('LABEL-AI-FUNCTION')}
                                    </label>
                                    <div className="switch-check">
                                        <input
                                            type="checkbox"
                                            id="usingAI"
                                            checked={getValue(settingData, 'usingAI')}
                                            readOnly
                                            disabled={!isProjectManager}
                                        />
                                        <label
                                            htmlFor="usingAI"
                                            onClick={e => onChangeData(e, 'usingAI')}
                                        >
                                            <span className="switch-text"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="groupSettingItem justify-content-start align-items-center">
                                    <label className="settingLable">
                                        {trI18n('LABEL-BASIC-PROMPT-CHATBOT')}
                                    </label>
                                    <div className="w-full" style={{ maxWidth: '65%' }}>
                                        {!basicPromptSetting ? (
                                            <TextField
                                                className="form-control-input form-control-wrapInput form-control-hg40 input-basic-chip"
                                                variant="outlined"
                                                spellCheck={false}
                                                autoComplete="seriously-please-don't-autocomplete"
                                                type="text"
                                                onBlur={e =>
                                                    handleOnBlurBasicPromptSetting(
                                                        e,
                                                        setSettingData,
                                                        setBasicPromptDetail,
                                                        setBasicPromptSetting,
                                                        setErrorBasicPrompt,
                                                        setIsLoading,
                                                        setIsDisableBtnSubmit,
                                                        setIsEdited
                                                    )
                                                }
                                                helperText={trI18n(errorBasicPrompt)}
                                                error={!Utils.isEmptyString(errorBasicPrompt)}
                                            />
                                        ) : (
                                            <>
                                                <div
                                                    className={`p-3 border border-solid rounded-md ${
                                                        errorBasicPrompt
                                                            ? 'border-red-600'
                                                            : 'border-slate-300'
                                                    }`}
                                                >
                                                    <Chip
                                                        style={{
                                                            width: 'auto',
                                                            maxWidth: '100%',
                                                            justifyContent: 'space-between'
                                                        }}
                                                        label={
                                                            <OverFlowTooltipWithCustomCss
                                                                value={
                                                                    Utils.convertJSONDataToObject(
                                                                        basicPromptDetail?.outline
                                                                    ).jp
                                                                }
                                                            />
                                                        }
                                                        onClick={() => {
                                                            if (
                                                                Utils.isEmptyObject(
                                                                    basicPromptSetting
                                                                )
                                                            )
                                                                return;
                                                            openPromptTicketPanel(
                                                                setIsLoading,
                                                                userDetail,
                                                                basicPromptDetail.id,
                                                                projectInuseDetail,
                                                                null,
                                                                addNewPanel,
                                                                setIsOpenAccessDeniedPopup
                                                            );
                                                        }}
                                                        onDelete={() =>
                                                            handleClickRemoveBasicPromptSetting(
                                                                setSettingData,
                                                                setBasicPromptDetail,
                                                                setBasicPromptSetting,
                                                                setIsDisableBtnSubmit,
                                                                setErrorBasicPrompt
                                                            )
                                                        }
                                                        deleteIcon={
                                                            <img
                                                                className="basic-chip-delete-icon"
                                                                src="/assets/image/delete-icon-rounded.svg"
                                                                alt="delete"
                                                            />
                                                        }
                                                        className="basic-chip setting-inputs text-blue-500"
                                                    />
                                                </div>
                                                {errorBasicPrompt && (
                                                    <>
                                                        <label className="text-red-600">
                                                            {trI18n(errorBasicPrompt)}
                                                        </label>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className="groupSetting advanced-setting-group">
                    {/* setting category  */}
                    <CategoryChatBotComponent
                        onClickToggleCategorySetting={onClickToggleCategorySetting}
                        categoryList={categoryList}
                        setCategoryList={setCategoryList}
                        onClickDetailCategoryChatbot={onClickDetailCategoryChatbot}
                        onRemoveCategory={onRemoveCategory}
                        setIsEdited={setIsEdited}
                        setRemovedCategoryId={setRemovedCategoryId}
                    />

                    {/* setting custom chat bot  */}
                    <div className="groupSetting mb-10 setting-custom-chatbot">
                        {/* setting select option if not resolved  */}
                        <div className="embeddedCode">
                            <div className="embeddedCode-label">{trI18n('PLKNOWLB016')}</div>
                            <Select
                                fullWidth
                                className="form-control form-control--wrap actionWhenNotResolve"
                                variant="outlined"
                                value={getValue(settingData, 'actionWhenNotResolve')}
                                onChange={e => onChangeData(e, 'actionWhenNotResolve')}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left'
                                    },
                                    getContentAnchorEl: null
                                }}
                            >
                                <MenuItem
                                    value={
                                        Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                                            .CREATE_TICKET_AND_CHAT_WITH_AGENT
                                    }
                                >
                                    {tr('チケット発行してライブチャットを行う')}
                                </MenuItem>
                                <MenuItem
                                    value={
                                        Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                                            .CREATE_TICKET_AND_FINISH
                                    }
                                >
                                    {tr('チケット発行して終了する')}
                                </MenuItem>
                                <MenuItem
                                    value={
                                        Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                                            .DISPLAY_FREE_MESSAGE
                                    }
                                >
                                    {tr('自由メッセージを表示する')}
                                </MenuItem>
                            </Select>
                        </div>
                        {settingData.actionWhenNotResolve ===
                            Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                                .DISPLAY_FREE_MESSAGE && (
                            <>
                                {/* setting free msg */}
                                <div className="embeddedCode">
                                    <RichTextEditorForSettingChatbot
                                        defaultValue={getValue(settingData, 'freeMsg')}
                                        setValue={setValueFreeMsg}
                                        value={valueFreeMsg}
                                        name="freeMsg"
                                        errorlist={errors}
                                        setErrors={setErrors}
                                        setIsEdited={setIsEdited}
                                        onChangePreviewSetting={onChangePreviewSetting}
                                        isUpdateData={isUpdateDataFreeMsg}
                                        setIsDisableBtnSubmit={setIsDisableBtnSubmit}
                                    />
                                </div>
                            </>
                        )}
                        {/* setting max number answers  */}
                        <div className="embeddedCode">
                            <div className="embeddedCode-label">
                                {trI18n('PLKNOWLB018')}
                                <span className="required">*</span>
                            </div>
                            <div className="maxNumberAnswer formNumber">
                                <TextField
                                    className="form-control-wrapInput form-control-hg32"
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    placeholder={trI18n('PLKNOWP002')}
                                    value={getValue(settingData, 'maxNumberAnswer').toString()}
                                    data-cy="add-tag-field-input-max-item-show"
                                    onChange={e => onChangeData(e.target.value, 'maxNumberAnswer')}
                                    onBlur={e => onValidateNumber('maxNumberAnswer')}
                                    error={getError(errors, 'maxNumberAnswer') ? true : false}
                                    helperText={trI18n(getError(errors, 'maxNumberAnswer'))}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <div className="formButton">
                                                    <Button
                                                        className="btnNumber up"
                                                        disabled={
                                                            getValue(
                                                                settingData,
                                                                'maxNumberAnswer'
                                                            ) >=
                                                            Constant.SETTING_CHAT_BOT
                                                                .MAX_LENGTH_ANSWER.MAX
                                                        }
                                                        onClick={e => {
                                                            setPreviewSetting(prev => ({
                                                                ...prev,
                                                                maxNumberAnswer: (settingData.maxNumberAnswer =
                                                                    parseInt(
                                                                        settingData.maxNumberAnswer ||
                                                                            0
                                                                    ) + 1)
                                                            }));
                                                            onValidateNumber('maxNumberAnswer');
                                                            setIsEdited(true);
                                                            setIsDisableBtnSubmit(false);
                                                        }}
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-nav.svg"
                                                            alt=""
                                                        />
                                                    </Button>
                                                    <Button
                                                        className="btnNumber down"
                                                        disabled={
                                                            getValue(
                                                                settingData,
                                                                'maxNumberAnswer'
                                                            ) <=
                                                            Constant.SETTING_CHAT_BOT
                                                                .MAX_LENGTH_ANSWER.MIN
                                                        }
                                                        onClick={e => {
                                                            setPreviewSetting(prev => ({
                                                                ...prev,
                                                                maxNumberAnswer: (settingData.maxNumberAnswer =
                                                                    parseInt(
                                                                        settingData.maxNumberAnswer
                                                                    ) - 1)
                                                            }));
                                                            onValidateNumber('maxNumberAnswer');
                                                            setIsEdited(true);
                                                            setIsDisableBtnSubmit(false);
                                                        }}
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-nav.svg"
                                                            alt=""
                                                        />
                                                    </Button>
                                                </div>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>
                        </div>
                        {/* setting number Hit KnowledgeTicket  */}
                        <div className="embeddedCode">
                            <div className="embeddedCode-label">
                                {trI18n('PLKNOWLB028')}
                                <span className="required">*</span>
                            </div>
                            <div className="maxNumberAnswer formNumber">
                                <TextField
                                    className="form-control-wrapInput form-control-hg32"
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    placeholder={trI18n('PLKNOWP005')}
                                    value={getValue(
                                        settingData,
                                        'numberHitKnowledgeTicket'
                                    ).toString()}
                                    data-cy="add-tag-field-input-max-item-show"
                                    onChange={e =>
                                        onChangeData(e.target.value, 'numberHitKnowledgeTicket')
                                    }
                                    onBlur={e => onValidateNumber('numberHitKnowledgeTicket')}
                                    error={
                                        getError(errors, 'numberHitKnowledgeTicket') ? true : false
                                    }
                                    helperText={trI18n(
                                        getError(errors, 'numberHitKnowledgeTicket')
                                    )}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <div className="formButton">
                                                    <Button
                                                        className="btnNumber up"
                                                        disabled={
                                                            getValue(
                                                                settingData,
                                                                'numberHitKnowledgeTicket'
                                                            ) >=
                                                            Constant.SETTING_CHAT_BOT
                                                                .NUMBER_HIT_KNOWLEDGE_TICKET.MAX
                                                        }
                                                        onClick={e => {
                                                            setPreviewSetting(prev => ({
                                                                ...prev,
                                                                numberHitKnowledgeTicket: (settingData.numberHitKnowledgeTicket =
                                                                    parseInt(
                                                                        settingData.numberHitKnowledgeTicket ||
                                                                            0
                                                                    ) + 1)
                                                            }));
                                                            onValidateNumber(
                                                                'numberHitKnowledgeTicket'
                                                            );
                                                            setIsDisableBtnSubmit(false);
                                                            setIsEdited(true);
                                                        }}
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-nav.svg"
                                                            alt=""
                                                        />
                                                    </Button>
                                                    <Button
                                                        className="btnNumber down"
                                                        disabled={
                                                            getValue(
                                                                settingData,
                                                                'numberHitKnowledgeTicket'
                                                            ) <=
                                                            Constant.SETTING_CHAT_BOT
                                                                .NUMBER_HIT_KNOWLEDGE_TICKET.MIN
                                                        }
                                                        onClick={e => {
                                                            setPreviewSetting(prev => ({
                                                                ...prev,
                                                                numberHitKnowledgeTicket: (settingData.numberHitKnowledgeTicket =
                                                                    parseInt(
                                                                        settingData.numberHitKnowledgeTicket
                                                                    ) - 1)
                                                            }));
                                                            onValidateNumber(
                                                                'numberHitKnowledgeTicket'
                                                            );
                                                            setIsDisableBtnSubmit(false);
                                                            setIsEdited(true);
                                                        }}
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-nav.svg"
                                                            alt=""
                                                        />
                                                    </Button>
                                                </div>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>
                        </div>

                        {/* setting optionDisplayLength */}
                        <div className="embeddedCode optionDisplayLength">
                            <div className="embeddedCode-label">
                                {trI18n('LABEL-MAX-NUMBER-CHARACTERS-DISPLAY-FOR-SELECT-OPTION')}
                                <span className="required">*</span>
                            </div>

                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={getBooleanValueOptionDisplayLength(settingData)}
                                    className="option-display-radio-group-btn"
                                    onChange={e => onChangeData(e, 'optionDisplayLengthRadio')}
                                >
                                    <FormControlLabel
                                        className="custom-radio"
                                        value={false}
                                        control={<Radio size="small" />}
                                        label={trI18n('LABEL-SHOW-FULL-TEXT')}
                                    />
                                    <FormControlLabel
                                        className="custom-radio"
                                        value={true}
                                        control={<Radio size="small" />}
                                        label={trI18n('LABEL-LIMIT-NUMBER-OF-CHARACTERS')}
                                    />
                                </RadioGroup>
                            </FormControl>

                            <div className="maxNumberAnswer formNumber">
                                <TextField
                                    className="form-control-wrapInput form-control-hg32"
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    placeholder={trI18n('PLKNOWP005')}
                                    disabled={!getBooleanValueOptionDisplayLength(settingData)}
                                    value={
                                        getValue(settingData, 'optionDisplayLength') ||
                                        getValue(settingData, 'optionDisplayLength') === ''
                                            ? getValue(
                                                  settingData,
                                                  'optionDisplayLength'
                                              ).toString()
                                            : Constant.SETTING_CHAT_BOT.MAX_OPTION_DISPLAY_LENGTH
                                                  .DEFAULT
                                    }
                                    data-cy="add-tag-field-input-max-item-show"
                                    onChange={e =>
                                        onChangeData(e.target.value, 'optionDisplayLength')
                                    }
                                    onBlur={e => onValidateNumber('optionDisplayLength')}
                                    error={getError(errors, 'optionDisplayLength') ? true : false}
                                    helperText={trI18n(getError(errors, 'optionDisplayLength'))}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <div className="formButton">
                                                    <Button
                                                        className="btnNumber up"
                                                        disabled={
                                                            !settingData?.optionDisplayLength ||
                                                            !getBooleanValueOptionDisplayLength(
                                                                settingData
                                                            ) ||
                                                            settingData?.optionDisplayLength >=
                                                                Constant.SETTING_CHAT_BOT
                                                                    .MAX_OPTION_DISPLAY_LENGTH.MAX
                                                        }
                                                        onClick={e => {
                                                            setPreviewSetting(prev => ({
                                                                ...prev,
                                                                optionDisplayLength: (settingData.optionDisplayLength =
                                                                    parseInt(
                                                                        settingData.optionDisplayLength ||
                                                                            0
                                                                    ) + 1)
                                                            }));
                                                            onValidateNumber('optionDisplayLength');
                                                            setIsDisableBtnSubmit(false);
                                                            setIsEdited(true);
                                                        }}
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-nav.svg"
                                                            alt=""
                                                        />
                                                    </Button>
                                                    <Button
                                                        className="btnNumber down"
                                                        disabled={
                                                            !settingData?.optionDisplayLength ||
                                                            !getBooleanValueOptionDisplayLength(
                                                                settingData
                                                            ) ||
                                                            settingData?.optionDisplayLength ===
                                                                Constant.SETTING_CHAT_BOT
                                                                    .MAX_OPTION_DISPLAY_LENGTH.MIN
                                                        }
                                                        onClick={e => {
                                                            if (
                                                                settingData?.optionDisplayLength ===
                                                                1
                                                            )
                                                                return;
                                                            setPreviewSetting(prev => ({
                                                                ...prev,
                                                                optionDisplayLength: (settingData.optionDisplayLength =
                                                                    parseInt(
                                                                        settingData.optionDisplayLength
                                                                    ) - 1)
                                                            }));
                                                            onValidateNumber('optionDisplayLength');
                                                            setIsDisableBtnSubmit(false);
                                                            setIsEdited(true);
                                                        }}
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-nav.svg"
                                                            alt=""
                                                        />
                                                    </Button>
                                                </div>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>
                        </div>

                        {/* setting image option  */}
                        <div className="groupSettingContent">
                            <div className="groupSettingItem">
                                <label className="settingLable">{trI18n('PLKNOWLB013')}</label>
                                <div className="switch-check">
                                    <input
                                        type="checkbox"
                                        id="useImageInAnswer"
                                        // defaultChecked={getValue(settingData, 'useImageInAnswer')}
                                        checked={getValue(settingData, 'useImageInAnswer')}
                                        readOnly
                                    />
                                    <label
                                        htmlFor="useImageInAnswer"
                                        onClick={e => onChangeData(e, 'useImageInAnswer')}
                                    >
                                        <span className="switch-text"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="groupSettingItem">
                                <label className="settingLable">{trI18n('SETTING_ENABLE_LIST_TICKET_ROBO')}</label>
                                <div className="switch-check">
                                    <input
                                        type="checkbox"
                                        id="enableListTicket"
                                        checked={getValue(settingData, 'enableListTicket')}
                                        readOnly
                                        disabled={!getValue(settingData, 'usingAI')}
                                    />
                                    <label
                                        htmlFor="enableListTicket"
                                        onClick={e => {
                                            if (!getValue(settingData, 'usingAI')) return;
                                            onChangeData(e, 'enableListTicket')
                                        }}
                                    >
                                        <span className="switch-text"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="groupSetting mb-10 setting-custom-chatbot">
                        <h3 className="style-setting-title">{tr('表示設定')}</h3>
                        {/* setting chatbotTextInHeader */}
                        <div className="embeddedCode">
                            <div className="embeddedCode-label">
                                {trI18n('PLKNOWLB019')}
                                <span className="required">*</span>
                            </div>
                            <TextField
                                fullWidth
                                variant="outlined"
                                name="chatbotTextInHeader"
                                className="form-control-wrapInput form-control-hg40"
                                value={getValue(settingData, 'chatbotTextInHeader')}
                                minRows={1}
                                maxRows={2}
                                onChange={e => onChangeData(e, 'chatbotTextInHeader')}
                                onBlur={e => {
                                    checkRequired('chatbotTextInHeader');
                                    onChangePreviewSetting('chatbotTextInHeader');
                                }}
                                error={getError(errors, 'chatbotTextInHeader') ? true : false}
                                helperText={tr(I18n.get(getError(errors, 'chatbotTextInHeader'))?.replace('＜X＞', '256'))}
                                placeholder={trI18n('PLKNOWP003')}
                            />
                        </div>
                        {/**icon header chatbot*/}
                        <SettingHeaderIconChatbot
                            croppedImage={croppedHeaderIcon}
                            setCroppedImage={setCroppedHeaderIcon}
                            settingData={settingData}
                            setSettingData={setSettingData}
                            errors={errors}
                            setErrors={setErrors}
                            setIsEdited={setIsEdited}
                            setPreviewSetting={setPreviewSetting}
                            reloadPage={reloadPage}
                            setIsDisableBtnSubmit={setIsDisableBtnSubmit}
                            label={'PLKNOWLB030'}
                            logoFileName={headerLogoName}
                            setLogoFileName={setHeaderLogoName}
                        />
                        {/* setting chatbotName */}
                        <div className="embeddedCode">
                            <div className="embeddedCode-label">
                                {trI18n('PLKNOWLB021')}
                                <span className="required">*</span>
                            </div>
                            <TextField
                                fullWidth
                                variant="outlined"
                                name="chatbotName"
                                className="form-control-wrapInput form-control-hg40"
                                value={getValue(settingData, 'chatbotName')}
                                minRows={1}
                                maxRows={2}
                                onChange={e => onChangeData(e, 'chatbotName')}
                                error={getError(errors, 'chatbotName') ? true : false}
                                helperText={tr(I18n.get(getError(errors, 'chatbotName'))?.replace('＜X＞', '256'))}
                                placeholder={trI18n('PLKNOWP004')}
                                onBlur={e => {
                                    checkRequired('chatbotName');
                                    onChangePreviewSetting('chatbotName');
                                }}
                            />
                        </div>
                        {/* setting logo */}
                        <SettingLogoChatbot
                            croppedImage={croppedImage}
                            setCroppedImage={setCroppedImage}
                            settingData={settingData}
                            setSettingData={setSettingData}
                            errors={errors}
                            setErrors={setErrors}
                            setIsEdited={setIsEdited}
                            setPreviewSetting={setPreviewSetting}
                            reloadPage={reloadPage}
                            setIsDisableBtnSubmit={setIsDisableBtnSubmit}
                            logoFileName={logoFileName}
                            setLogoFileName={setLogoFileName}
                        />
                        {/* button send icon */}
                        <SettingSendIconChatbot
                            croppedImage={croppedSendIcon}
                            setCroppedImage={setCroppedSendIcon}
                            settingData={settingData}
                            setSettingData={setSettingData}
                            errors={errors}
                            setErrors={setErrors}
                            setIsEdited={setIsEdited}
                            setPreviewSetting={setPreviewSetting}
                            reloadPage={reloadPage}
                            setIsDisableBtnSubmit={setIsDisableBtnSubmit}
                            logoFileName={sendLogoName}
                            setLogoFileName={setSendLogoName}
                        />
                    </div>
                    <div className="groupSetting mb-10 setting-custom-chatbot">
                        <div className="embeddedCode form-oversize">
                            <div className="label-stylesheet">
                                <div className="embeddedCode-label">
                                    {trI18n('PLKNOWLB005')} <span className="required">*</span>
                                </div>
                                <Button
                                    startIcon={<BackToDefault />}
                                    onClick={() => setIsShowDialogBacktoDefault(true)}
                                    onKeyPress={e => e.preventDefault()}
                                >
                                    {trI18n('PLKNOWBT002')}
                                </Button>
                            </div>

                            <TextField
                                multiline
                                fullWidth
                                variant="outlined"
                                name="styleSheet"
                                value={getValue(settingData, 'styleSheet')}
                                minRows={3}
                                maxRows={3}
                                onChange={e => onChangeData(e, 'styleSheet')}
                                error={getError(errors, 'styleSheet') ? true : false}
                                helperText={trI18n(getError(errors, 'styleSheet'))?.replace(
                                    /＜X＞|{{maxLength}}/g,
                                    '200000'
                                )}
                                placeholder={trI18n('USER010PL001')}
                            />

                            {isCssFallback && (
                                <p className="css-fallback-message">
                                    {trI18n('CSS-FALLBACK-ERROR')}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className="groupSetting mb-10 setting-custom-chatbot">
                        <div className="embeddedCode form-oversize">
                            <div className="label-stylesheet">
                                <div className="embeddedCode-label">
                                    {trI18n('KL_ROBO_MSG_CONFIG_LABEL')}
                                </div>
                                <Button
                                    startIcon={<BackToDefault />}
                                    onClick={() => setIsShowDialogResetMessageConfig(true)}
                                    onKeyPress={e => e.preventDefault()}
                                >
                                    {trI18n('PLKNOWBT002')}
                                </Button>
                            </div>

                            <TextField
                                multiline
                                fullWidth
                                variant="outlined"
                                name="messageConfig"
                                value={getValue(settingData, 'messageConfig')}
                                minRows={10}
                                maxRows={10}
                                onChange={e => onChangeData(e, 'messageConfig')}
                                error={getError(errors, 'messageConfig') ? true : false}
                                helperText={trI18n(getError(errors, 'messageConfig'))}
                                placeholder={trI18n('KL_ROBO_MSG_CONFIG_PLACE_HOLDER')}
                                spellCheck={false}
                            />
                        </div>
                    </div>
                </div>
                <div className="groupSetting generateUrl">
                    <div className="generateUrl-group">
                        <div className="generateUrl-header">
                            <div className="copyIframe">
                                <h3 className="generateUrl-title">{tr('配置用スクリプト取得')}</h3>
                                <Button
                                    className="buttonCopyIframe"
                                    onClick={e =>
                                        navigator.clipboard.writeText(
                                            Utils.generateChatBotScript(projectInuseDetail.id)
                                        )
                                    }
                                    disabled={isNotError()}
                                >
                                    <img src="/assets/image/copy-iframe.svg" alt="Copy iframe" />
                                    {trI18n('USER10BTN004')}
                                </Button>
                            </div>
                        </div>

                        {/* setting HtmlScript */}
                        <div className="embeddedCode genScript">
                            <TextField
                                multiline
                                fullWidth
                                variant="outlined"
                                name="htmlScript"
                                value={Utils.generateChatBotScript(projectInuseDetail.id)}
                                minRows={2}
                                maxRows={5}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div></div>
                </div>
                {/* </div> */}
                <ConfirmDialog
                    isOpen={isShowDialogReload}
                    msgConfirm={trI18n('COMMSG030')}
                    okCallBack={() => window.location.reload()}
                />
                <ConfirmDialog
                    isOpen={isOpenConfirmReset}
                    msgConfirm={trI18n('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                    okCallBack={() => {
                        setIsOpenConfirmReset(false);
                        setCroppedImage(null);
                        setIsDisableBtnSubmit(true);
                        onSubmitSetting(
                            corporationDetail,
                            projectInuseDetail,
                            settingData,
                            valueFreeMsg,
                            croppedHeaderIcon,
                            croppedImage,
                            croppedSendIcon,
                            setCroppedImage,
                            setCroppedHeaderIcon,
                            setCroppedSendIcon,
                            errors,
                            setErrors,
                            enqueueSnackbar,
                            setIsLoading,
                            setReloadPage,
                            isEdited,
                            setIsShowDialogReload,
                            dataHtmlScript,
                            categoryList,
                            chatBotCategorySetting,
                            setChatbotCategorySetting,
                            titleCategory,
                            userDetail.id,
                            chatBotCategoryList,
                            setChatbotCategoryList,
                            setIsDisableBtnSubmit,
                            setIsEdited,
                            props?.API,
                            basicPromptDetail,
                            setErrorBasicPrompt,
                            setIsShowUploadError
                        );
                    }}
                    closeCallBack={onClickNoWhenClickDontSave}
                    cancelCallBack={() => {
                        setIsOpenConfirmReset(false);
                    }}
                    textSubmit={trI18n('COMBTN002')}
                    textClose={trI18n('COMBTN007')}
                    isShowClassnameButton={false}
                />
                <ConfirmDialog
                    isOpen={!Utils.isEmptyString(removedCategoryId)}
                    msgConfirm={trI18n('COMMSG028')}
                    closeCallBack={() => setRemovedCategoryId(null)}
                    okCallBack={() => {
                        onRemoveCategory(removedCategoryId);
                        setIsEdited(true);
                        setIsDisableBtnSubmit(false);
                        setRemovedCategoryId(null);
                    }}
                    textClose={trI18n('COMBTN007')}
                />

                <ConfirmDialog
                    isOpen={isShowUploadError}
                    msgConfirm={trI18n('SAVE-SETTING-UPLOAD-FAILED')}
                    okCallBack={() => {
                        setIsShowUploadError(false);
                        setReloadPage(Date.now().toString());
                    }}
                />
            </div>
        );
    };

    return (
        <>
            {isOpenSettingCategoty ? (
                <>
                    <LoadingPanel isLoading={isLoading} />
                    <SettingCategory
                        onClickToggleCategorySetting={onClickToggleCategorySetting}
                        API={props?.API}
                        corporationId={corporationDetail.id}
                        projectInuseDetail={projectInuseDetail}
                        formQAList={formQAList}
                        customerViewList={customerViewList}
                        categoryList={categoryList}
                        setCategoryList={setCategoryList}
                        chatBotCategorySetting={chatBotCategorySetting}
                        setChatbotCategorySetting={setChatbotCategorySetting}
                        isEdited={isEdited}
                        setIsEdited={setIsEdited}
                        titleCategory={titleCategory}
                        setTitleCategory={setTitleCategory}
                        isEditCategoryDetail={isEditCategoryDetail}
                        setIsEditCategoryDetail={setIsEditCategoryDetail}
                        chatBotCategoryList={chatBotCategoryList}
                        setChatbotCategoryList={setChatbotCategoryList}
                        editCategoryId={editCategoryId}
                        setEditCategoryId={setEditCategoryId}
                        setIsDisableBtnSubmit={setIsDisableBtnSubmit}
                    />
                </>
            ) : (
                renderChatbotSetting()
            )}
            <CancelTabsDialog
                argsAll={{
                    isConfirmCancelTabs: isConfirmCancelTabs,
                    setIsConfirmCancelTabs: setIsConfirmCancelTabs,
                    closePanelTab: closePanelTab,
                    tabId: props.tabId,
                    panelId: props.panelId,
                    panelList: panelList
                }}
            />

            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={trI18n('KNOWDEMSG005')}
                okCallBack={() => window.location.reload()}
            />

            <ConfirmDialog
                isOpen={isShowDialogBacktoDefault}
                msgConfirm={`${trI18n('PLKNOWLB032')}${trI18n('MSG-CM-BACK-TO-DEFAULT')}`}
                closeCallBack={() => setIsShowDialogBacktoDefault(false)}
                okCallBack={async () => await onHandleBacktoDefault()}
                textClose={trI18n('COMBTN007')}
            />

            <ConfirmDialog
                isOpen={isShowDialogResetMessageConfig}
                msgConfirm={trI18n('MSG_CM_CONFIRM_RESET_TO_KL_ROBO_MSG_CONFIG_DEFAULT')}
                closeCallBack={() => setIsShowDialogResetMessageConfig(false)}
                okCallBack={onHandleResetMessageConfig}
                textClose={trI18n('COMBTN007')}
            />
        </>
    );
}
